export const SET_ALL = 'SET_ALL';
export const ADD_ANALYTICS_MESSAGES = 'ADD_ANALYTICS_MESSAGES';
export const SET_MESSAGE_AS_READ = 'SET_MESSAGE_AS_READ';
